
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podPts",
      function () {
        return require("private-next-pages/podPts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podPts"])
      });
    }
  